module.exports = __webpack_public_path__ + "img/svg/versus-match-box.c4c5eacb0babc2ace5d6538234993835.svg";